/* eslint-disable import/extensions */
import { HomePage } from 'pages/HomePage';
import { AuthCodePage } from 'pages/AuthCodePage';
import { useRoutes } from 'react-router';
import { LoginPage } from 'pages/LoginPage';
import { AuthPage } from 'pages/AuthPage';
import { NotFoundPage } from 'pages/404';
import { ProductTypePage } from 'pages/ProductTypePage';
import { ReCaptchaPage } from 'pages/ReCAPTCHA';
import { PATHS } from './constants';

export const NavigateList = () => {
	const routes = useRoutes([
		// {
		// 	path: PATHS.AUTH_CODE_PAGE,
		// 	element: <AuthCodePage />,
		// },
		// {
		// 	path: PATHS.AUTH_PAGE,
		// 	element: <AuthPage />,
		// },
		{
			path: PATHS.HOME_PAGE,
			element: <HomePage />,
		},
		// {
		// 	path: PATHS.LOGIN_PAGE,
		// 	element: <LoginPage />,
		// },
		{
			path: PATHS.PRODUCT_TYPE_PAGE,
			element: <ProductTypePage />,
		},
		{
			path: '*',
			element: <HomePage />,
		},
	]);
	return routes;
};
